export enum ErrorContext {
  ORGANIZATION = "ORGANIZATION",
}
